import { render } from "./AdvantagesComponent.vue?vue&type=template&id=6c5a714f"
import script from "./AdvantagesComponent.vue?vue&type=script&lang=js"
export * from "./AdvantagesComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__